import { defineMessages } from 'react-intl'

export default defineMessages({
  twitter: {
    id: 'share.twitter',
    defaultMessage: 'Share on Twitter',
  },
  facebook: {
    id: 'share.facebook',
    defaultMessage: 'Share on Facebook',
  },
  line: {
    id: 'share.line',
    defaultMessage: 'Share on Line',
  },
  link: {
    id: 'share.link',
    defaultMessage: 'Copy link / Embed',
  },
  share: {
    id: 'share.share',
    defaultMessage: 'Share',
  },
})
